<template>
  <div class="rotate_notice full flex">
    <template v-if="direction==0">
      <div class="rotate_vertical_icon rotate_icon"><img src="../_img/rotate_icon.png" /></div>
      <div class="rotate_vertical_text">请打开旋转 横屏观看</div>
    </template>
    <template v-if="direction==1">
      <div class="rotate_horizontal_icon rotate_icon"><img src="../_img/rotate_icon.png" /></div>
      <div class="rotate_horizontal_text">请竖屏观看</div>
    </template>
  </div>
</template>


<style scoped>
  .rotate_notice {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    z-index: 999;
  }

  .rotate_vertical_icon {
    position: relative;
    width: 20%;
  }

  .rotate_vertical_text {
    color: black;
    font-size: 16px;
    margin-top: 10%;
  }

  .rotate_horizontal_icon {
    position: relative;
    width: 20%;
  }

  .rotate_horizontal_text {
    color: black;
    font-size: 14px;
    margin-top: 5%;
  }

  .rotate_icon {
    -webkit-animation: rotate_icon .5s alternate infinite;
  }

  @-webkit-keyframes rotate_icon {
    0% {
      -webkit-transform: rotate(5deg);
    }

    100% {
      -webkit-transform: rotate(-5deg);
    }

  }
</style>


<script>
  export default {
    props: {
      direction: {
        type: Number,
        default: function() {
          return 1
        }
      },
    },
    data() {
      return {

      };
    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },

  }
</script>
